import React from 'react';
import FooterLinks from '../../views/auth/FooterLinks';
import { useTranslation } from 'react-i18next';

const LoginTermsAndConditions = () => {
  const { t } = useTranslation();
  return (
    <div className="d-flex flex-column justify-content-center align-items-center footer-items-wrapper">
      <p style={{fontFamily:" Arial, Helvetica, sans-serif"}} className={'font-size-12 privacy-policy'}>{t("signing_agreement")}</p>
      <FooterLinks />
    </div>
  );
};

export default LoginTermsAndConditions;
